import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function LockClosedMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path fillRule="evenodd" clipRule="evenodd" d="M8.535 3.535A4.9 4.9 0 0116.9 7v3.1H18a2.9 2.9 0 012.9 2.9v6a2.9 2.9 0 01-2.9 2.9H6A2.9 2.9 0 013.1 19v-6A2.9 2.9 0 016 10.1h1.1V7a4.9 4.9 0 011.435-3.465zM8.9 10.1h6.2V7a3.1 3.1 0 10-6.2 0v3.1zM6 11.9A1.1 1.1 0 004.9 13v6A1.1 1.1 0 006 20.1h12a1.1 1.1 0 001.1-1.1v-6a1.1 1.1 0 00-1.1-1.1H6zm6 2.2a.9.9 0 01.9.9v2a.9.9 0 01-1.8 0v-2a.9.9 0 01.9-.9z"  /></Svg>;
}
export default LockClosedMedium;